var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessMeassageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25589_19050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C17.523 2.5 22 6.977 22 12.5C22 18.023 17.523 22.5 12 22.5C6.477 22.5 2 18.023 2 12.5C2 6.977 6.477 2.5 12 2.5ZM15.535 8.881L10.585 13.831L8.465 11.71C8.37216 11.6171 8.26192 11.5434 8.14059 11.4931C8.01926 11.4428 7.8892 11.4168 7.75785 11.4168C7.49258 11.4167 7.23814 11.522 7.0505 11.7095C6.86286 11.897 6.75739 12.1514 6.7573 12.4166C6.7572 12.6819 6.86249 12.9364 7.05 13.124L9.808 15.882C9.91015 15.9842 10.0314 16.0653 10.1649 16.1206C10.2984 16.1759 10.4415 16.2044 10.586 16.2044C10.7305 16.2044 10.8736 16.1759 11.0071 16.1206C11.1406 16.0653 11.2618 15.9842 11.364 15.882L16.95 10.296C17.1376 10.1084 17.2431 9.85386 17.2431 9.5885C17.2431 9.32314 17.1376 9.06864 16.95 8.881C16.7624 8.69336 16.5079 8.58794 16.2425 8.58794C15.9771 8.58794 15.7226 8.69336 15.535 8.881Z",
    fill: "#32BC69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25589_19050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMeassageIcon);
export default __webpack_public_path__ + "static/media/success-meassage-icon.883574b93862a991d026689921c61430.svg";
export { ForwardRef as ReactComponent };